import { IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import LanguageDto from "../../models/LanguageDto";
import { useLanguage } from "../../provider/LanguageContext";
import { useRestaurantData } from "../../provider/RestaurantDataContext";
import './LanguageSwitcher.css';

function showLanguageFlag(language: LanguageDto): React.ReactNode {
    return (
        <div className="circular--landscape" >
            <img
                src={language?.imageUrl}
                alt={language?.imageUrl?.substring(language?.imageUrl?.lastIndexOf('/') + 1)}
            />
        </div>
    );
}

export default function LanguageSwitcher() {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { language, setLanguage } = useLanguage();
    const { restaurantData } = useRestaurantData();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (restaurantData.languages?.filter((languageCurr) => languageCurr.id !== language.id).length === 0) return;
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleMenuClick = (language: LanguageDto) => {
        handleClose();
        setLanguage(language);
    }

    return (
        <>
            <IconButton onClick={handleClick} sx={{ pr: 0 }}>
                {showLanguageFlag(language)}
            </IconButton>
            <Menu
                id="menu-language"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {
                    restaurantData.languages
                        ?.filter((languageCurr) => languageCurr?.id !== language?.id)
                        .map((language) => (
                            <MenuItem key={language.id} onClick={() => handleMenuClick(language)}>{showLanguageFlag(language)}</MenuItem>
                        ))
                }
            </Menu>
        </>
    );
}